import React, { useEffect, useState } from "react";
import { Layout, Tabs } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ROUTES_MAP } from "../../routes/routesMap";

import "./AdminLayout.scss";
import { useAppSelector } from "../../redux/store";

const { Content } = Layout;

const HeaderTabs = () => {
  const { t } = useTranslation("dashboard");
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState<string>(
    ROUTES_MAP.dashboard.admin.liveStreams
  );

  const items = [
    { key: ROUTES_MAP.dashboard.admin.blockedRegistrations, label: t("adminNav.blockedRegistrations") },
    { key: ROUTES_MAP.dashboard.admin.abuseIncidents, label: t("adminNav.abuseIncidents") },
    {
      key: ROUTES_MAP.dashboard.admin.liveStreams,
      label: t("adminNav.liveStreams"),
    },
    {
      key: ROUTES_MAP.dashboard.admin.users,
      label: t("adminNav.users"),
    },
  ];

  useEffect(() => {
    setActiveKey(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === ROUTES_MAP.dashboard.admin.index) {
      navigate(ROUTES_MAP.dashboard.admin.liveStreams);
    }
  }, []);

  const onChange = (key: string) => {
    navigate(key);
  };

  return (
    <>
      <Tabs
        activeKey={activeKey}
        items={items}
        onChange={onChange}
      />
      <div className="tab-content">
        <Outlet />
      </div>
    </>
  );
};

const AdminLayout: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);
  if (!user?.role || user?.role !== "admin") {
    return null;
  }
  return (
    <Layout
      className="adminLayout"
      style={{
        background: "transparent",
      }}
    >
      <Content>
        <HeaderTabs />
      </Content>
    </Layout>
  );
};

export default AdminLayout;
